<template>
    <div id='login-page'>
        <div id='login-container'>
            <!-- Left side with logo -->
            <div class='left-panel'>
                <div class='logo-section'>
                    <div class='logo-placeholder'></div>
                </div>
            </div>

            <!-- Right side with login form -->
            <div class='right-panel'>
                <div class='visibility-wrapper' v-show='!register'>
                    <!-- Email Verification Success Message -->
                    <div v-if="showVerificationSuccess" class="verification-success-message">
                        <div class="success-icon">✓</div>
                        <p>Your email has been verified successfully! You can now sign in.</p>
                    </div>

                    <!-- Verification Required Message -->
                    <div v-if="showVerificationRequired" class="verification-required-message">
                        <div class="info-icon">ⓘ</div>
                        <p>Please check your email and click the verification link before signing in.</p>
                        <button class="resend-link" @click="resendVerificationEmail">Didn't receive the email? Click here to resend</button>
                    </div>

                    <!-- <button class='google-btn'>Continue with Google</button> --> <!-- call Google auth method here @click='handleGoogleAuth' -->
                    
                    <!-- <div class='divider'> -->
                        <!-- <span>or</span> -->
                    <!-- </div> -->

                    <h2 class='form-title'>Sign in with Email</h2>
                    
                    <form>
                        <input class='input-field' type="email" v-model="loginEmail" placeholder="Enter email" />
                        <div class='password-container'>
                            <input 
                                class='input-field' 
                                :type="showPassword ? 'text' : 'password'" 
                                v-model="loginPwd" 
                                placeholder="Enter password" 
                            />
                            <button 
                                type="button" 
                                class='password-toggle' 
                                @click="togglePasswordVisibility"
                            >
                                <img 
                                    v-if="showPassword" 
                                    src="../../assets/passwordEyeOpen.png" 
                                    alt="Hide password" 
                                    class="eye-icon"
                                />
                                <img 
                                    v-else 
                                    src="../../assets/passwordEyeClosed.png" 
                                    alt="Show password" 
                                    class="eye-icon"
                                />
                            </button>
                        </div>
                        
                        <a href="#" class="forgot-password" @click.prevent="$router.push('/forgot-password')">Forgot Password?</a>
                        
                        <button class='login-btn' type='submit' @click.prevent='handleLogin'>Login</button>
                        
                        <p class='signup-link'>
                            or <a href="#" @click.prevent='goRegister'>Register Here</a>
                        </p>
                    </form>
                </div>

                <!-- Registration Section -->
                <div class='visibility-wrapper' v-show='register'>
                    <div class='visibility-wrapper' v-show='!registerNext'>
                        <h2 class='form-title'>Register as</h2>
                        <form>
                            <center id='checkbox'>
                                <label class='checker' @click="chooseTester">
                                    <input type="radio" name="fav_language">
                                    Tester
                                </label>
                                <label class='checker' @click="chooseDeveloper">
                                    <input type="radio" name="fav_language">
                                    Developer
                                </label>
                            </center>
                            
                            <div class='input-group'>
                                <input 
                                    class='input-field' 
                                    :class="{ 'error': nameError }"
                                    type="text" 
                                    v-model="registerName" 
                                    placeholder="Name" 
                                    @blur="validateName"
                                />
                                <div class='error-message' v-if="nameError">{{ nameError }}</div>
                            </div>

                            <div class='input-group'>
                                <input 
                                    class='input-field' 
                                    :class="{ 'error': emailError }"
                                    type="email" 
                                    v-model="registerEmail" 
                                    placeholder="Email Address" 
                                    @blur="validateEmail"
                                />
                                <div class='error-message' v-if="emailError">{{ emailError }}</div>
                            </div>

                            <div class='input-group'>
                                <div class='password-container'>
                                    <input 
                                        class='input-field' 
                                        :class="{ 'error': passwordError }"
                                        :type="showRegisterPassword ? 'text' : 'password'" 
                                        v-model="registerPwd" 
                                        placeholder="Password" 
                                        @blur="validatePassword"
                                    />
                                    <button 
                                        type="button" 
                                        class='password-toggle' 
                                        @click="toggleRegisterPasswordVisibility"
                                    >
                                        <img 
                                            v-if="showRegisterPassword" 
                                            src="../../assets/passwordEyeOpen.png" 
                                            alt="Hide password" 
                                            class="eye-icon"
                                        />
                                        <img 
                                            v-else 
                                            src="../../assets/passwordEyeClosed.png" 
                                            alt="Show password" 
                                            class="eye-icon"
                                        />
                                    </button>
                                </div>
                                <div class='error-message' v-if="passwordError">{{ passwordError }}</div>
                            </div>

                            <div class='input-group'>
                                <div class='password-container'>
                                    <input 
                                        class='input-field' 
                                        :class="{ 'error': confirmPasswordError }"
                                        :type="showRegisterConfirmPassword ? 'text' : 'password'" 
                                        v-model="registerCpwd" 
                                        placeholder="Confirm Password" 
                                        @blur="validateConfirmPassword"
                                    />
                                    <button 
                                        type="button" 
                                        class='password-toggle' 
                                        @click="toggleRegisterConfirmPasswordVisibility"
                                    >
                                        <img 
                                            v-if="showRegisterConfirmPassword" 
                                            src="../../assets/passwordEyeOpen.png" 
                                            alt="Hide password" 
                                            class="eye-icon"
                                        />
                                        <img 
                                            v-else 
                                            src="../../assets/passwordEyeClosed.png" 
                                            alt="Show password" 
                                            class="eye-icon"
                                        />
                                    </button>
                                </div>
                                <div class='error-message' v-if="confirmPasswordError">{{ confirmPasswordError }}</div>
                            </div>

                            <!-- TOS Checkbox -->
                            <div class='input-group'>
                                <div class='terms-checkbox-container'>
                                    <label class='terms-checkbox-label'>
                                        <input 
                                            type="checkbox" 
                                            v-model="agreeToTerms" 
                                            class='terms-checkbox'
                                            @change="validateTerms"
                                        />
                                        <span class='terms-text'>
                                            I am 13 years of age or older and agree to the terms of the  
                                            <a href="#" @click.prevent="openTermsOfService" class='terms-link'>User Agreement</a> 
                                            and 
                                            <a href="#" @click.prevent="openPrivacyPolicy" class='terms-link'>Privacy Policy</a>.
                                        </span>
                                    </label>
                                </div>
                                <div class='error-message' v-if="termsError">{{ termsError }}</div>
                            </div>

                            <div class='button-group'>
                                <button class='cancel-button' type='submit' @click.prevent='goLogin'>Cancel</button>
                                <button class='register-button' type='submit' @click.prevent='handleNext'>{{nextButtonText}}</button>
                            </div>
                        </form>
                    </div>
                    
                    <div class='visibility-wrapper' v-show='registerNext'>
                        <div class='visibility-wrapper' v-show='!registerTags'>
                            <h2 class='form-title'>About you</h2>
                            <form>
                                <input class='input-field' type="text" v-model="registerNickname" placeholder="Nickname" />
                                <input class='input-field' type="text" v-model="registerBio" placeholder="Bio" />

                                <div class='button-group'>
                                    <button class='cancel-button' type='submit' @click.prevent='goRegister'>Back</button>
                                    <button class='register-button' type='submit' @click.prevent='handleInfo'>Next</button>
                                </div>
                            </form>
                        </div>

                        <div class='visibility-wrapper' v-show='registerTags'>
                            <h2 class='form-title'>About you</h2>
                            <form>
                                <div id="tags-container" class="scroll-container">
                                    <div v-for="(fieldObject, field_index) in testerFields" 
                                    :key="fieldObject.field_index" :id="fieldObject.field_index">
                                        <h3 class='tag-section-text'>{{fieldObject.fieldName}}</h3>
                                        <div>
                                            <b-button v-for="(fieldValue, value_index) in fieldObject.fieldValues"
                                                :key="value_index" :id="`button_${field_index}_${value_index}`" size="sm" class="m-1"
                                                @click="handleFieldValue(fieldValue, fieldObject.fieldName, field_index)"
                                                :class="{
                                                    'blue-button': fieldObject.fieldName === 'platform' && fieldValue.isAdded,
                                                    'green-button': fieldObject.fieldName === 'behavior' && fieldValue.isAdded,
                                                    'red-button': fieldObject.fieldName === 'genre' && fieldValue.isAdded,
                                                    'purple-button': fieldObject.fieldName === 'profile' && fieldValue.isAdded,
                                                    'yellow-button': fieldObject.fieldName === 'purchasingBehavior' && fieldValue.isAdded,
                                                    'pink-button': fieldObject.fieldName === 'gender' && fieldValue.isAdded
                                                }">
                                            {{fieldValue.value}}
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class='button-group'>
                                    <button class='cancel-button' type='submit' @click.prevent='goNext'>Back</button>
                                    <button class='register-button' type='submit' @click.prevent='handleTags'>Sign up</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Account Type Selection Modal -->
        <div v-if="showAccountTypeModal" class="modal-overlay" @click="closeAccountTypeModal">
            <div class="modal-content" @click.stop>
                <h3>Choose Account Type</h3>
                <p>Please select the type of account you'd like to create:</p>
                <div class="account-type-buttons">
                    <button class="account-type-btn tester-btn" @click="selectAccountType('tester')">
                        <strong>Tester</strong>
                        <span>Test games and provide feedback</span>
                    </button>
                    <button class="account-type-btn developer-btn" @click="selectAccountType('developer')">
                        <strong>Developer</strong>
                        <span>Hire testers for your games</span>
                    </button>
                </div>
            </div>
        </div>

        <!-- Welcome Popup for First Time Users -->
        <div v-if="showWelcomePopup" class="modal-overlay" @click="closeWelcomePopup">
            <div class="welcome-popup-content" @click.stop>
                <button class="btn-close-circle--dark" @click="closeWelcomePopup">×</button>
                
                <!-- Developer Welcome Content -->
                <div v-if="welcomeUserType === 'developer'" class="welcome-content">
                    <h2>Welcome, Game Developer!</h2>
                    <div class="welcome-sections">
                        <div class="welcome-section">
                            <h3>Dashboard</h3>
                            <p>The Dashboard serves as your central hub for managing and monitoring all your playtesting activities, providing a comprehensive overview of your projects. It offers a quick way to view the status of ongoing tests and access recent reports.</p>
                        </div>
                        <div class="welcome-section">
                            <h3>Add a Playtester</h3>
                            <p>Searching for a Playtester is a powerful way to discover and recruit the ideal testers for your game. It allows you to filter and sort through our extensive network of players using detailed criteria like demographics, device and gaming preferences.</p>
                        </div>
                        <div class="welcome-section">
                            <h3>Survey System</h3>
                            <p>The Survey System provides you with a robust set of tools to create and deploy customized surveys to your playtesters. This feature enables you to gather targeted, structured feedback that is automatically linked to game projects.</p>
                        </div>
                        <div class="welcome-section">
                            <h3>Recording Gameplay</h3>
                            <p>Recording Gameplay automatically captures and records playtest sessions, providing you with a complete view of the player's experience, including their screen, audio, and webcam. This system allows you to add timestamped notes to specific moments.</p>
                        </div>
                    </div>
                </div>

                <!-- Playtester Welcome Content -->
                <div v-if="welcomeUserType === 'tester'" class="welcome-content">
                    <h2>Welcome, Playtester!</h2>
                    <div class="welcome-sections">
                        <div class="welcome-section">
                            <h3>Dashboard</h3>
                            <p>The Dashboard serves as your central hub for managing and monitoring all your playtesting activities. It offers a quick way to view the status of ongoing tests, discover new games and access recent achievements.</p>
                        </div>
                        <div class="welcome-section">
                            <h3>Discover</h3>
                            <p>The Discover page is your gateway to find and participate in exciting new games that match your interests. You can easily browse and filter available opportunities by game genre and platform to find the perfect games for you.</p>
                        </div>
                        <div class="welcome-section">
                            <h3>Profile</h3>
                            <p>Your Profile page is where you can manage your personal information and gaming preferences to ensure you are matched with the most relevant playtest opportunities.</p>
                        </div>
                        <div class="welcome-section">
                            <h3>Achievements</h3>
                            <p>The Achievements page is a visual showcase of your contributions to the platform, highlighting your completed playtests and milestone achievements. It allows you to track your progress as a playtester and gives developers a clear view of your experience.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>  
</template>

<script>
    import Loading from '../loading/index.vue';
    import firebase, { auth } from '../../db.js';
    import {mapGetters} from 'vuex';
    import UserObject from "../../Firestore/UserObject";
    import { validateEmail, validatePassword } from "../../util/validation";

    export default {
        name: "login",
        computed: {
            nextButtonText() {
                return this.registerUserType === 'tester' ? 'Next' : 'Sign up';
            },
        },
        components: {
            Loading
        },
        data() {
            return {
                isLoading: false,
                msg: "login now",
                register: false,
                registerNext: false,
                registerTags: false,
                showAccountTypeModal: false,
                pendingGoogleUser: null,
                
                showVerificationSuccess: false,
                showVerificationRequired: false,
                pendingVerificationEmail: '',
                
                // Welcome popup variables
                showWelcomePopup: false,
                welcomeUserType: '',
                
                loginInfo: {
                    email: 1,
                    password: 1
                },
                registerInfo: {
                    userName: 1,
                    email: 1,
                    password: 1,
                    confirmPassword: 1
                },
                loginEmail: "",
                loginPwd: "",
                registerName: "",
                registerEmail: "",
                registerPwd: "",
                registerCpwd: "",
                registerNickname: "",
                // registerGender: "",
                registerBio: "",
                registerUserType: "",
                defaultAvatar: require("../../assets/avatar_default.png"),
                
                platformSelected: [],
                behaviorSelected: [],
                genreSelected: [],
                profileSelected: [],
                purchasingBehaviorSelected: [],
                genderSelected: [],
                selectedFieldValues: [],
                variantsList: ["primary", "success",
                "danger", "warning", "info", "light",
                "dark"],
                testerFields: [
                    { fieldName : "platform", fieldValues: [{value: "Mobile", isAdded: false}, {value: "Game Console", isAdded: false},
                     {value: "PC/Laptop", isAdded: false}, {value: "Handheld", isAdded: false}, {value: "VR", isAdded: false}
                    ]},
                    { fieldName : "behavior", fieldValues: [{value: "Competition", isAdded: false}, {value: "Completion", isAdded: false},
                     {value: "Community/Social", isAdded: false}, {value: "Design", isAdded: false}, {value: "Destruction", isAdded: false},
                     {value: "Fantasy", isAdded:false}, {value: "Story", isAdded: false}
                    ]},
                    { fieldName : "genre", fieldValues: [{value: "Action", isAdded: false}, {value: "Adventure", isAdded: false},
                    {value: "Casual/Puzzle", isAdded: false}, {value: "Multiplayer Online", isAdded: false}, {value: "Role Playing Game", isAdded: false},
                    {value: "Shooter", isAdded: false}, {value: "Simulation", isAdded: false},
                    {value: "Sports", isAdded: false}, {value: "Strategy", isAdded: false}
                    ]},
                    { fieldName : "profile", fieldValues: [{value: "Gamer in a Past Life", isAdded: false}, {value: "Conventional", isAdded: false},
                     {value: "Popcorn/Recreational", isAdded: false}, {value: "Ultimate Gamer", isAdded: false}, {value: "Time Filler", isAdded: false}
                    ]},
                    { fieldName : "purchasingBehavior", fieldValues: [{value: "One Time Game Purchases", isAdded: false}, {value: "Additional Game Content", isAdded: false},
                     {value: "Lootboxes", isAdded: false}, {value: "Characters", isAdded: false}, {value: "Subsciptions", isAdded: false},
                     {value: "Cosmetics", isAdded: false}, {value: "Free to Play", isAdded: false}
                    ]},
                    { fieldName : "gender", fieldValues: [{value: "Man", isAdded: false}, {value: "Woman", isAdded: false},
                     {value: "Two-Spirit", isAdded: false}, {value: "Non-Binary", isAdded: false}, {value: "Gender not Listed/ Prefer not to say", isAdded: false}
                    ]},
                ],

                showPassword: false,
                showRegisterPassword: false,
                showRegisterConfirmPassword: false,
                
                // Validation errors
                nameError: '',
                emailError: '',
                passwordError: '',
                confirmPasswordError: '',
                termsError: '',
                agreeToTerms: false,
            }
        },
        mounted() {
            if (window.localStorage.getItem("userType")) {             
                this.$router.push({
                    name: 'dashboard',
                })
            }
            
            // check for email verification success
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('verified') === 'true') {
                this.showVerificationSuccess = true;
                
                const newUrl = window.location.pathname;
                window.history.replaceState({}, document.title, newUrl);
                
                setTimeout(() => {
                    this.showVerificationSuccess = false;
                }, 5000);
            }
            
            // handle email verification from Firebase link
            UserObject.handleEmailVerification();
        },
        methods: {
            async handleGoogleAuth() {
                try {
                    this.isLoading = true;
                    const result = null; //await auth.signInWithPopup(provider);

                    const user = result.user;
                    console.log('Google auth successful, user:', user.email);
                    
                    // try to login with existing account first
                    try {
                        const loginResult = await UserObject.loginUser({
                            email: user.email,
                            googleAuth: true
                        });
                        
                        console.log('Login successful:', loginResult);
                        this.handleSuccessfulLogin(loginResult);
                        
                    } catch (error) {
                        console.log('Login failed, checking if user needs to register:', error);
                        
                        // user doesn't exist, need to register
                        if (error.error === "User not found" || error.error === "Invalid credentials") {
                            this.pendingGoogleUser = user;
                            this.showAccountTypeModal = true;
                        } else {
                            console.error('Unexpected login error:', error);
                            throw new Error(error.error || error.message || 'Login failed');
                        }
                    }
                    
                } catch (error) {
                    console.error('Google auth error:', error);
                    
                    let errorMessage = 'Google authentication failed. Please try again.';
                    
                    if (error.code === 'auth/popup-closed-by-user') {
                        errorMessage = 'Authentication cancelled. Please try again.';
                    } else if (error.code === 'auth/popup-blocked') {
                        errorMessage = 'Popup was blocked. Please allow popups and try again.';
                    } else if (error.code === 'auth/network-request-failed') {
                        errorMessage = 'Network error. Please check your connection and try again.';
                    } else if (error.message && !error.message.includes('User not found')) {
                        errorMessage = `Authentication failed: ${error.message}`;
                    }
                    
                    alert(errorMessage);
                } finally {
                    this.isLoading = false;
                }
            },

            selectAccountType(userType) {
                this.registerUserType = userType;
                this.showAccountTypeModal = false;
                
                if (this.pendingGoogleUser) {
                    this.registerWithGoogle(userType);
                }
            },

            async registerWithGoogle(userType) {
                try {
                    this.isLoading = true;
                    const user = this.pendingGoogleUser;
                    
                    console.log('Registering Google user:', user.email, 'as', userType);
                    
                    const registrationData = {
                        name: user.displayName || '',
                        userType: userType,
                        email: user.email,
                        googleAuth: true,
                        img: user.photoURL || this.defaultAvatar,
                        nickName: user.displayName || '',
                        bio: '',
                        platform: userType === 'tester' ? [] : undefined,
                        behavior: userType === 'tester' ? [] : undefined,
                        genre: userType === 'tester' ? [] : undefined,
                        profile: userType === 'tester' ? [] : undefined,
                        purchasingBehavior: userType === 'tester' ? [] : undefined,
                        gender: userType === 'tester' ? [] : undefined
                    };

                    const registerResult = await UserObject.registerUser(registrationData);
                    console.log('Registration successful:', registerResult);
                    
                    if (registerResult.success) {
                        // For Google users, we can log them in immediately
                        const loginResult = await UserObject.loginUser({
                            email: user.email,
                            googleAuth: true
                        });
                        this.handleSuccessfulLogin(loginResult, true); // Pass true for new registration
                    } else {
                        throw new Error(registerResult.error);
                    }
                    
                } catch (error) {
                    console.error('Google registration error:', error);
                    alert('Registration failed: ' + (error.message || 'Please try again.'));
                } finally {
                    this.isLoading = false;
                    this.pendingGoogleUser = null;
                }
            },

            async resendVerificationEmail() {
                if (!this.pendingVerificationEmail) {
                    alert('Please enter your email address first.');
                    return;
                }

                try {
                    this.isLoading = true;
                    
                    // Sign in temporarily to resend verification email
                    const userCredential = await auth.signInWithEmailAndPassword(
                        this.pendingVerificationEmail, 
                        'temp'
                    );
                } catch (authError) {
                    alert('To resend the verification email, please try registering again with the same email address, or contact support if you continue having issues.');
                } finally {
                    this.isLoading = false;
                }
            },

            handleSuccessfulLogin(res, isNewRegistration = false) {
                let numType = -1;
                // determine user type via response
                if (res.data.userType === "tester") {
                    numType = 0;
                } else if (res.data.userType === "developer") {
                    numType = 1;
                } else {
                    numType = 2;
                }

                window.localStorage.setItem("userType", numType);
                window.localStorage.setItem("userId", res.data.id);
                window.localStorage.setItem("userEmail", res.data.email);
                window.localStorage.setItem("userAvatar", res.data.img);
                
                if (res.data.userType === "tester") {
                    // TODO: implement notification dot for new surveys
                }

                // Show welcome popup for new registrations or first-time users
                if (isNewRegistration) {
                    this.welcomeUserType = res.data.userType;
                    this.showWelcomePopup = true;
                } else {
                    // Route to dashboard immediately for returning users
                    this.routeToDashboard();
                }

                //Show Achievement popup if there is an achievement
                if (res.data.achieved) {
                    console.log("new loginStreak achieved");
                    this.$snackbar.showSnackbar(`New Achievement: Login Streak of ${res.data.val}!`, "#28a745");
                }
            },

            handleSuccessfulRegistration(res) {
                let numType = -1;
                if (res.data.userType === "tester") {
                    numType = 0;
                } else if (res.data.userType === "developer") {
                    numType = 1;
                } else {
                    numType = 2;
                }
                window.localStorage.setItem("userType", numType);
                
                // Show verification required message and store email for potential resend
                this.showVerificationRequired = true;
                this.pendingVerificationEmail = this.registerEmail;
                
                this.goLogin();
            },

            routeToDashboard() {
                this.$router.push({
                    name: 'dashboard',
                    params: {
                        tag: 0
                    }
                });
            },

            closeWelcomePopup() {
                this.showWelcomePopup = false;
                this.routeToDashboard();
            },

            closeAccountTypeModal() {
                this.showAccountTypeModal = false;
                this.pendingGoogleUser = null;
            },

            handleFieldValue: function(fieldValue, fieldObject, field_index) {
                const numberOfVariants = this.variantsList.length
                const variant = this.variantsList[field_index % numberOfVariants]

                const targetValue = this.testerFields[field_index].fieldValues.find(value => value.value === fieldValue.value)
                targetValue.isAdded = !targetValue.isAdded

                if (targetValue.isAdded) {
                    this.selectedFieldValues.push({ fieldValue, variant, field_index })
                } else {
                    const indexToRemove = this.selectedFieldValues.findIndex(
                    (selectedValue) =>
                        selectedValue.fieldValue === fieldValue &&
                        selectedValue.field_index === field_index
                    )
                    if (indexToRemove !== -1) {
                        this.selectedFieldValues.splice(indexToRemove, 1)
                    }
                }

                if (fieldObject == "platform") {
                    this.platformSelected = this.testerFields[field_index].fieldValues
                    .filter((value) => value.isAdded)
                    .map((value) => value.value)
                } else if (fieldObject == "behavior") {
                    this.behaviorSelected = this.testerFields[field_index].fieldValues
                    .filter((value) => value.isAdded)
                    .map((value) => value.value)
                } else if (fieldObject == "genre") {
                    this.genreSelected = this.testerFields[field_index].fieldValues
                    .filter((value) => value.isAdded)
                    .map((value) => value.value)
                } else if (fieldObject == "profile") {
                    this.profileSelected = this.testerFields[field_index].fieldValues
                    .filter((value) => value.isAdded)
                    .map((value) => value.value)
                } else if (fieldObject == "purchasingBehavior") {
                    this.purchasingBehaviorSelected = this.testerFields[field_index].fieldValues
                    .filter((value) => value.isAdded)
                    .map((value) => value.value)
                } else if (fieldObject == "gender") {
                    this.genderSelected = this.testerFields[field_index].fieldValues
                    .filter((value) => value.isAdded)
                    .map((value) => value.value)
                }
                console.log(this.selectedFieldValues)
            },

            chooseTester: function() {
                this.registerUserType = "tester"
            },

            chooseDeveloper: function() {
                this.registerUserType = "developer"
            },

            changeInput: function() {},

            goRegister: function() {
                this.register = true;
                this.registerNext = false;
                this.registerTags = false;
                this.showVerificationRequired = false;
                this.showVerificationSuccess = false;
            },
            
            goNext: function() {
                this.registerNext = true;
                this.registerTags = false;
            },

            goTags: function() {
                this.registerTags = true;
            },

            goLogin: function() {
                this.register = false;
                this.registerNext = false;
                this.registerTags = false;
            },

            handleLogin: function() {
                let that = this;
                if (this.loginEmail.length == 0) {
                    alert("Please enter your email");
                    return;
                }
                if (this.loginPwd.length == 0) {
                    alert("Please enter your password");
                    return;
                }
                
                let trimmedEmail = this.loginEmail.trim();

                if (trimmedEmail.includes(' ') || this.loginPwd.includes(' ')) {
                    alert("Hey, you shouldn't put spaces into your email or password.");
                } else {
                    this.isLoading = true;
                    this.showVerificationRequired = false;
                    
                    UserObject.loginUser({
                        email: this.loginEmail.trim(),
                        password: this.loginPwd.trim()
                    })
                    .then(res => {
                        this.handleSuccessfulLogin(res);
                        that.isLoading = false;
                    })
                    .catch(e => {
                        console.log("Login error caught:", e);
            
                        // Extract the raw error message safely depending on how UserObject structures failures
                        let errorMessage = "";
                        if (e && e.error && typeof e.error === 'object' && e.error.message) {
                            errorMessage = e.error.message; // Handles the nested format from your raw log
                        } else if (e && e.message) {
                            errorMessage = e.message;
                        } else if (typeof e === 'string') {
                            errorMessage = e;
                        }

                        // Check conditions using the extracted string
                        if (errorMessage.includes('verify your email')) {
                            this.showVerificationRequired = true;
                            this.pendingVerificationEmail = this.loginEmail.trim();
                        } else if (errorMessage.includes('INVALID_LOGIN_CREDENTIALS')) {
                            alert("Incorrect email or password. Please try again.");
                        } else {
                            alert(errorMessage || "An unexpected error occurred during login.");
                        }
                        
                        this.isLoading = false;

                        /*// Check if the error is due to unverified email
                        if (e.error && e.error.includes('verify your email')) {
                            this.showVerificationRequired = true;
                            this.pendingVerificationEmail = this.loginEmail.trim();
                        } else {
                            console.log("error is here");
                            alert(e.error);
                        }
                        that.isLoading = false;
                        */
                    });
                }
            },

            handleNext: function() {
                let that = this;
                let correct = true;

                if (correct && !this.agreeToTerms) {
                    this.termsError = "You must agree to the Terms of Service and Privacy Policy to continue";
                    correct = false;
                } else {
                    this.termsError = '';
                }
                if (this.registerName.length == 0) {
                    alert("Please enter your name");
                    correct = false;
                }
                if (correct && this.registerUserType.length == 0) {
                    alert("Please choose your user type");
                    correct = false;
                }
                if (correct) {
                    const emailError = validateEmail(this.registerEmail);
                    if (emailError) {
                        alert(emailError);
                        correct = false;
                    }
                }
                if (correct && this.registerCpwd != this.registerPwd) {
                    alert("Confirmed password does not match your password");
                    correct = false;
                }
                if (correct) {
                    const passwordError = validatePassword(this.registerPwd);
                    if (passwordError) {
                        alert(passwordError);
                        correct = false;
                    }
                }
                if (correct) {
                    if (this.registerUserType == "tester") {
                        this.goNext();
                    } else {
                        this.isLoading = true;
                        UserObject.registerUser({
                            name: this.registerName,
                            userType: this.registerUserType,
                            email: this.registerEmail,
                            password: this.registerPwd,
                            img: this.defaultAvatar,
                            nickName: this.registerNickname,
                            gender: this.registerGender,
                            bio: this.registerBio,
                            platform: this.platformSelected,
                            behavior: this.behaviorSelected,
                            genre: this.genreSelected,
                            profile: this.profileSelected,
                            purchasingBehavior: this.purchasingBehaviorSelected,
                            gender: this.genderSelected
                        })
                        .then(res => {
                            this.handleSuccessfulRegistration(res);
                            that.isLoading = false;
                        })
                        .catch(e => { // request failure handler
                            console.log(e);
                            alert(e.error || 'Registration failed. Please try again.');
                            that.isLoading = false;
                        });
                    }
                } else {
                    this.goRegister();
                }
            },

            handleInfo: function() {
                console.log(this.registerUserType);
                let that = this;
                let correct = true;
                if (this.registerNickname.length == 0) {
                    alert("Please enter your nickname");
                    correct = false;
                }
                if (correct) {
                    this.goTags();
                } else {
                    this.goNext();
                }
            },

            handleTags: function() {
                let that = this;
                let correct = true;
                if (correct) {
                    this.isLoading = true;
                    UserObject.registerUser({
                        name: this.registerName,
                        userType: this.registerUserType,
                        email: this.registerEmail,
                        password: this.registerPwd,
                        img: this.defaultAvatar,
                        nickName: this.registerNickname,
                        bio: this.registerBio,
                        platform: this.platformSelected,
                        behavior: this.behaviorSelected,
                        genre: this.genreSelected,
                        profile: this.profileSelected,
                        purchasingBehavior: this.purchasingBehaviorSelected,
                        gender: this.genderSelected
                    })
                    .then(res => {
                        this.handleSuccessfulRegistration(res);
                        that.isLoading = false;
                    })
                    .catch(e => { // request failure handler
                        console.log(e);
                        alert(e.error || 'Registration failed. Please try again.');
                        that.isLoading = false;
                    });
                } else {
                    this.goTags();
                }
            },

            handleCancel: function() {},

            togglePasswordVisibility() {
                this.showPassword = !this.showPassword;
            },
            
            toggleRegisterPasswordVisibility() {
                this.showRegisterPassword = !this.showRegisterPassword;
            },
            
            toggleRegisterConfirmPasswordVisibility() {
                this.showRegisterConfirmPassword = !this.showRegisterConfirmPassword;
            },
            
            validateName() {
                if (this.registerName.trim().length < 2) {
                    this.nameError = 'Name must be at least 2 characters long';
                } else {
                    this.nameError = '';
                }
            },
            
            validateEmail() {
                this.emailError = validateEmail(this.registerEmail);
            },

            validatePassword() {
                this.passwordError = validatePassword(this.registerPwd);
            },
            
            validateConfirmPassword() {
                if (this.registerCpwd !== this.registerPwd) {
                    this.confirmPasswordError = 'Passwords do not match';
                } else {
                    this.confirmPasswordError = '';
                }
            },

            validateTerms() {
                if (!this.agreeToTerms) {
                    this.termsError = 'You must agree to the Terms of Service and Privacy Policy to continue';
                } else {
                    this.termsError = '';
                }
            },

            openTermsOfService() {
                this.$router.push('/terms-of-service');
            },

            openPrivacyPolicy() {
                this.$router.push('/privacy-policy');
            },
        }
    }
</script>

<style scoped>

#login-page {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #edecf8;
    display: flex;
    align-items: center;
    justify-content: center;
}

#login-container {
    width: 1200px;
    height: 750px;
    background: white;
    border-radius: 20px;
    box-shadow: 0 20px 40px #bfb3e7;
    display: flex;
    overflow: hidden;
}

.left-panel {
    width: 50%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.left-panel::after {
    content: '';
    position: absolute;
    top: 60px;
    right: 0;
    width: 2px;
    height: calc(100% - 110px);
    background-color: #d0d0d0;
    z-index: 1;
}

.logo-section {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}

.logo-placeholder {
    width: 550px;
    height: 440px;
    background-image: url("../../assets/HorizontalGradientLogo-17.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.right-panel {
    width: 50%;
    padding: 80px 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.verification-success-message {
    background: #e8f5e8;
    border: 2px solid #4caf50;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
    text-align: center;
}

.verification-success-message .success-icon {
    color: #4caf50;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 8px;
}

.verification-success-message p {
    color: #2e7d32;
    margin: 0;
    font-weight: 500;
}

.verification-required-message {
    background: #fff3cd;
    border: 2px solid #ffc107;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
    text-align: center;
}

.verification-required-message .info-icon {
    color: #ff9800;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 8px;
}

.verification-required-message p {
    color: #856404;
    margin: 0 0 10px 0;
    font-weight: 500;
}

.resend-link {
    background: none;
    border: none;
    color: #2196f3;
    text-decoration: underline;
    cursor: pointer;
    font-size: 14px;
    padding: 0;
}

.resend-link:hover {
    color: #1976d2;
}

.google-btn {
    width: 100%;
    height: 60px;
    background: #333;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
    margin-bottom: 25px;
    transition: background 0.3s ease;
}

.google-btn:hover {
    background: #555;
}

.divider {
    text-align: center;
    margin: 25px 0;
    position: relative;
    color: #999;
    font-size: 16px;
}

.divider:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: #e0e0e0;
}

.divider span {
    background: white;
    padding: 0 15px;
    position: relative;
}

.form-title {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin-bottom: 30px;
}

.input-group {
    margin-bottom: 18px;
}

.input-group .password-container {
    margin-bottom: 0;
}

.input-field.error {
    border-color: #f44336;
    background-color: #fff5f5;
}

.error-message {
    color: #f44336;
    font-size: 14px;
    margin-top: -3px;
    margin-left: 2px;
    line-height: 1.2;
}

.password-toggle {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.password-toggle span {
    line-height: 1;
}

.input-field {
    width: 100%;
    height: 55px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 0 20px;
    margin-bottom: 18px;
    font-size: 16px;
    transition: border-color 0.3s ease;
    box-sizing: border-box;
}

.input-field:focus {
    outline: none;
    border-color: #667eea;
}

.password-container {
    position: relative;
    margin-bottom: 0;
    width: 100%;
}

.password-container .input-field {
    width: 100%;
    padding-right: 55px;
    box-sizing: border-box;
}

.eye-icon {
    width: 20px;
    height: 20px;
    object-fit: contain;
    transition: opacity 0.2s ease;
}

.eye-icon:hover {
    opacity: 0.7;
}

.password-toggle {
    position: absolute;
    right: 20px;
    top: 40%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.forgot-password {
    color: #ff7222;
    text-decoration: none;
    font-size: 16px;
    display: block;
    text-align: right;
    margin-bottom: 30px;
}

.login-btn {
    width: 100%;
    height: 60px;
    background: #ff7222;;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
    margin-bottom: 25px;
    transition: background 0.3s ease;
}

.login-btn:hover {
    background: #c8652c;
}

.signup-link {
    text-align: center;
    color: #999;
    font-size: 16px;
}

.signup-link a {
    color: #ff7222;
    text-decoration: none;
}

#checkbox {
    margin: 20px 0;
}

.checker {
    margin: 0 20px;
    cursor: pointer;
    color: #333;
    font-size: 16px;
}

.button-group {
    display: flex;
    gap: 15px;
    margin-top: 25px;
}

.terms-checkbox-container {
    margin-bottom: 0;
}

.terms-checkbox-label {
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    font-size: 14px;
    color: #666;
    line-height: 1.4;
}

.terms-checkbox {
    margin-right: 10px;
    margin-top: 2px;
    flex-shrink: 0;
}

.terms-text {
    flex: 1;
}

.terms-link {
    color: #2196f3;
    text-decoration: none;
}

.terms-link:hover {
    text-decoration: underline;
}

.cancel-button, .register-button {
    flex: 1;
    height: 55px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
}

.cancel-button {
    background: #f5f5f5;
    color: #666;
}

.cancel-button:hover {
    background: #e0e0e0;
}

.register-button {
    background: #2196f3;
    color: white;
}

.register-button:hover {
    background: #1976d2;
}

.tag-section-text {
    text-transform: capitalize;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 18px 0 12px 0;
}

.scroll-container {
    max-height: 200px;
    overflow-y: auto;
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.scroll-container::-webkit-scrollbar {
    display: none;
}

/* Tag button styles */
.blue-button {
    background-color: #2196f3 !important;
    color: white !important;
    border: none !important;
}

.green-button {
    background-color: #4caf50 !important;
    color: white !important;
    border: none !important;
}

.red-button {
    background-color: #f44336 !important;
    color: white !important;
    border: none !important;
}

.purple-button {
    background-color: #9c27b0 !important;
    color: white !important;
    border: none !important;
}

.yellow-button {
    background-color: #ffeb3b !important;
    color: black !important;
    border: none !important;
}

.pink-button {
    background-color: #e91e63 !important;
    color: white !important;
    border: none !important;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 40px;
    border-radius: 15px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    text-align: center;
    max-width: 500px;
    width: 90%;
}

.modal-content h3 {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
}

.modal-content p {
    font-size: 16px;
    color: #666;
    margin-bottom: 30px;
    line-height: 1.5;
}

.account-type-buttons {
    display: flex;
    gap: 20px;
    justify-content: center;
}

.account-type-btn {
    flex: 1;
    padding: 25px 20px;
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    background: white;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.account-type-btn:hover {
    border-color: #2196f3;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(33, 150, 243, 0.2);
}

.account-type-btn strong {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    display: block;
}

.account-type-btn span {
    font-size: 14px;
    color: #666;
    line-height: 1.3;
}

.tester-btn:hover {
    border-color: #ff9e2e;
    box-shadow: 0 5px 15px rgba(76, 175, 80, 0.2);
}

.developer-btn:hover {
    border-color: #8019ff;
    box-shadow: 0 5px 15px rgba(255, 152, 0, 0.2);
}

/* Welcome Popup Styles */
.welcome-popup-content {
    background: white;
    padding: 0;
    border-radius: 15px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    max-width: 700px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
    position: relative;
}



.welcome-content {
    padding: 40px;
    text-align: left;
}

.welcome-content h2 {
    font-size: 28px;
    font-weight: 600;
    color: #333;
    margin-bottom: 30px;
    text-align: center;
}

.welcome-sections {
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.welcome-section {
    border-left: 4px solid #2196f3;
    padding-left: 20px;
    background: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
}

.welcome-section h3 {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
}

.welcome-section p {
    font-size: 16px;
    color: #666;
    line-height: 1.5;
    margin: 0;
}

@media (max-width: 768px) {
    #login-container {
        width: 95%;
        height: 95%;
        flex-direction: column;
    }
    
    .left-panel, .right-panel {
        width: 100%;
    }
    
    .left-panel {
        height: 250px;
    }
    
    .right-panel {
        padding: 40px;
    }
    
    .logo-placeholder {
        width: 250px;
        height: 120px;
    }

    .account-type-buttons {
        flex-direction: column;
        gap: 15px;
    }
    
    .modal-content {
        padding: 30px 20px;
    }

    .welcome-popup-content {
        max-width: 95%;
        max-height: 90vh;
    }

    .welcome-content {
        padding: 30px 20px;
    }

    .welcome-content h2 {
        font-size: 24px;
    }

    .welcome-section {
        padding: 15px;
    }

    .welcome-section h3 {
        font-size: 18px;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/layout/Login.vue